import React, { useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { formatProjectDate } from "../../../controllers/common";
import moment from "moment";
import { usePermissions } from "../../../controllers/PermissionContext";
const OrdersDetails = () => {
  const PERMISSION = usePermissions("promoCodes");
  const location = useLocation();
  const state = location.state.items;
  const [orderData, setOrderData] = useState(state ?? []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div>
          <div className="orders_main_contaniner">
            <div>
              <nav class="navbar navbar-light  justify-content-between w-100 navbar_content">
                <Link
                  to="/order/list"
                  class="navbar-brand common_inventory_heading"
                >
                  {/* <IoArrowBack className="orders_now_IoArrow" /> */}
                  Orders Details :
                </Link>
                <Link to={"/promocodes/order"}>
                  <React.Fragment>
                    <button type="button" className="btn btn-secondary">
                      {" "}
                      <ArrowLeftOutlined /> Back{" "}
                    </button>
                  </React.Fragment>
                </Link>
              </nav>
            </div>
            <div className="order_now_card_title">
              <div className="card">
                <div className="card-body order_now_date_and_time_section">
                  <div>
                    <span className="orders_now_billing_details_heading">
                      Order No: {orderData?.order_no || ""}
                    </span>
                    <address className="order_now_address_date_and_time">
                      <span>
                        {moment(formatProjectDate(orderData?.createdAt)).format("MMM DD, YYYY, HH:mm")}
                      </span>
                    </address>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-lg-8">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="mb-3 d-flex justify-content-between">
                      <div>
                        <span className="orders_now_billing_details_heading">
                          Buyer's Details
                        </span>
                      </div>
                    </div>
                    <address className="order_now_address">
                      <span>
                        Name : {orderData?.buyer_first_name}{" "}
                        {orderData?.buyer_last_name}
                      </span>
                      <br />
                      <span>Phone No. : {orderData?.buyer_mobile}</span>
                    </address>
                  </div>
                </div>
                {(PERMISSION.fullAccess === 'Y' || PERMISSION?.coupon === 'Y') && (
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="mb-3 d-flex justify-content-between">
                        <div>
                          <span className="orders_now_billing_details_heading">
                            Coupon Code :
                          </span>
                        </div>
                      </div>
                      <address className="order_now_address">{orderData?.coupon_code}</address>
                    </div>
                  </div>
                )}
                {(PERMISSION.fullAccess === 'Y' || PERMISSION?.voucher === 'Y') && (
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="mb-3 d-flex justify-content-between">
                        <div>
                          <span className="orders_now_billing_details_heading">
                            Voucher Details
                          </span>
                        </div>
                      </div>
                      <table className="table table-borderless orders_now_table">
                        <thead>
                          <tr>
                            <th>Voucher Number</th>
                            <th>Points</th>
                            <th>Expiry Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderData?.voucher_number?.length > 0 ? (
                            orderData.voucher_number.map((voucher, index) => (
                              <tr key={index}>
                                <td>{voucher?.voucher_number || "N/A"}</td>
                                <td>{voucher?.points || "N/A"}</td>
                                <td>{moment(voucher?.expiry_date).format('DD-MM-YYYY')}</td>
                                <td>{voucher?.status || "N/A"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">No vouchers available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              </div>

              <div className="col-lg-4">
                <div className="card mb-4">
                  <div className="card-body">
                    <span className="orders_now_billing_details_heading">
                      Seller Details
                    </span>
                    <address className="order_now_address">
                      <span>
                        Name: {orderData?.seller_first_name}{" "}
                        {orderData?.seller_last_name}
                      </span>
                      <br />
                      <span>Phone No. : {orderData?.seller_mobile}</span>
                      <br />
                      <span>POS No. : {orderData?.seller_pos_number}</span>
                      <br />
                      <span>POS Serial No. : {orderData?.seller_user_id?.pos_serial_id}</span>
                      <br />
                      <span>Version: {orderData?.version}</span>
                    </address>
                  </div>
                </div>

                <div className="card mb-4">
                  <div className="card-body">
                    <span className="orders_now_billing_details_heading">
                      Promocode Details
                    </span>
                    <address className="order_now_address">
                      <span>Code: {orderData?.code}</span>
                      <br />
                      <span>
                        {/* Coupons: {orderData?.coupon_code.split(",").join(", ")} */}
                      </span>
                      <br />
                      <span>Points: {orderData?.points}</span>
                      <br />
                      <span>Total Points: {orderData?.total_point}</span>
                    </address>
                  </div>
                </div>
                {/* <div className="card mb-4">
      <div className="card-body">
        <span className="orders_now_billing_details_heading">
          Shipping Address
        </span>
        <address className="order_now_address">
          <span>
            {orderData?.deliveryAddress?.firstName}{" "}
            {orderData?.deliveryAddress?.lastName} (
            {orderData?.deliveryAddress?.phone})
            <br />
            {orderData?.deliveryAddress?.flatOrHouseNumber}{" "}
            {orderData?.deliveryAddress?.floor}{" "}
            {orderData?.deliveryAddress?.landmark}
            <br />
            {orderData?.deliveryAddress?.city}{" "}
            {orderData?.deliveryAddress?.state}{" "}
            {orderData?.deliveryAddress?.country}
          </span>
        </address>
      </div>
    </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default OrdersDetails;
